export default (doc) => {
  if (doc && doc.docAvatar) {
    return doc.docAvatar;
  } else {
    return require('../../static/img/doctor.m.png');
  }
}



// WEBPACK FOOTER //
// ./src/utils/docAva.js